export default __webpack_public_path__ + "static/media/swvl-business-logo.566ba342.svg";